import { LINK } from '@constants';
import { ArrowRight, Row, Typography, Wait } from '@viewup/ui';
import Link from 'next/link';

export const CheckBeforeApplyButton = () => {
  return (
    <Link href={LINK.CHECK_BEFORE_APPLY} target='_blank'>
      <Row
        alignItems='center'
        bgColor='bg.primary'
        border='1 solid border.secondary'
        br={16}
        justifyContent='space-between'
        px={16}
        py={12}
      >
        <Row alignItems='center' gap={16}>
          <Wait />
          <Typography color='text.secondary' fontType='body2.medium'>
            잠깐! 신청 전, 먼저 확인해 주세요!
          </Typography>
        </Row>

        <ArrowRight />
      </Row>
    </Link>
  );
};
